import type { Element } from "React";
import Bitcoin from "./bitcoin.svg";
type Props = {
  className?: string;
};

const IconBitcoin = (props: Props): Element<"svg"> => (
  <img
    className={`${props.className} icon-bitcoin`}
    src={Bitcoin}
    alt="Bitcoin Icon"
  />
);

export default IconBitcoin;
